import { useQuery } from 'react-query';
import { queryAllformationSessions } from './useFormationSessions.query';
import { UseFormationSessionsOptions } from './useFormationSessions.types';
import { AllFormationSessionsResponse } from '../../../types/api/endpoints/formations/allFormationSessions.types';

export const ALL_FORMATION_SESSIONS_QUERY_KEY = 'ALL_FORMATION_SESSIONS';

export const useFormationSessions = (options?: UseFormationSessionsOptions) => {
  return useQuery<AllFormationSessionsResponse, Error>(
    ALL_FORMATION_SESSIONS_QUERY_KEY,
    () => queryAllformationSessions(),
    options
  );
};
